/**
 * Textos (`en`) del tall «selfchecks» de Qualitat i APPCC. Tall propi: no es toca `en.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const selfChecksEn = {
  'backoffice.selfChecks': {
    subtitle:
      'The checks the team does every day, week or month (cleaning, temperatures, pests…): what has to be checked and what has been recorded.',
    tabsLabel: 'Self-check sections',
    tabRecords: 'Records',
    tabMissed: 'Missed records',
    tabTemplates: 'Templates',
    loadError: 'The data could not be loaded. Please try again.',
    loading: 'Loading…',

    // Enums
    kind_cleaning: 'Cleaning and disinfection',
    kind_temperature: 'Temperatures',
    kind_pests: 'Pest control',
    kind_custom: 'Other',
    frequency_daily: 'Daily',
    frequency_weekly: 'Weekly',
    frequency_monthly: 'Monthly',
    fieldType_ok_ko: 'OK / KO',
    fieldType_number: 'Number',
    fieldType_text: 'Text',
    fieldType_photo: 'Photo',
    result_ok: 'OK',
    result_ko: 'KO',

    // Periods
    periodWeek: 'Week {{week}} · {{from}} – {{to}}',

    // Records
    filterTemplate: 'Template',
    filterTemplateAll: 'All templates',
    filterResult: 'Result',
    filterResultAll: 'All',
    filterFrom: 'From day',
    filterTo: 'To day',
    recordsEmpty: 'There are no self-check records yet.',
    recordsEmptyFiltered: 'No record matches the filters.',
    recordsTruncated: 'Showing the {{limit}} most recent records. Narrow the filters to see others.',
    recordPeriod: 'Period',
    recordDoneBy: 'Done by {{name}} · {{when}}',
    unknownPerson: 'Unknown person',
    templateInactive: '{{name}} (inactive)',
    templateUnknown: '(template not available)',
    notesLabel: 'Notes',
    fieldUnavailable: '(field removed)',
    valueOutOfRange: 'Out of range',
    valueNoAnswer: 'No answer',
    valueRange: 'range {{min}} – {{max}}',
    valueRangeMin: 'minimum {{min}}',
    valueRangeMax: 'maximum {{max}}',
    photoView: 'View photo',
    photoOpening: 'Opening…',
    photoError: 'The photo could not be opened.',
    ncLabel: 'Non-conformity',
    ncLinksError: 'The links to the non-conformities could not be loaded.',

    // Missed records
    missedIntro:
      'Periods in which a self-check was due and has no record. Each template counts from the day it was created until it was deactivated. The current period does not show up until it ends.',
    missedRangeHint: 'One year at most; the last day is yesterday.',
    missedEmpty: 'No period was missed in this interval. All up to date.',
    missedEmptyNoTemplates: 'There are no templates yet. Create the base ones in the Templates tab.',
    missedCount_one: '{{count}} missed period',
    missedCount_other: '{{count}} missed periods',
    missedColTemplate: 'Template',
    missedColFrequency: 'Frequency',
    missedColPeriod: 'Period',
    missedColDue: 'Due',
    dueTitle: 'Due now',
    dueHint: 'Templates that have no record yet in their current period.',
    dueEmpty: 'Every self-check due now is done.',
    duePending: 'Pending',

    // Templates
    templatesTitle: 'Self-check templates',
    templatesSubtitle:
      'What has to be checked, how often and where. A deactivated template stops being due, but the records it already has are kept.',
    colName: 'Name',
    colKind: 'Type',
    colFrequency: 'Frequency',
    colZone: 'Zone',
    colEquipment: 'Equipment',
    colFields: 'Fields',
    newTemplate: 'New template',
    editTemplate: 'Edit template',
    searchLabel: 'Search by name, type or zone',
    filterKindAll: 'All types',
    filterFrequencyAll: 'All frequencies',
    emptyTemplates:
      'There are no templates yet. You can create the three base ones (cleaning and disinfection, temperatures and pests) and adapt them.',
    seedAction: 'Create the base templates',
    seeding: 'Creating…',
    seedCreated_one: '{{count}} base template was created.',
    seedCreated_other: '{{count}} base templates were created.',
    seedNone: 'The base templates were already there: nothing was created.',
    seedError: 'The base templates could not be created.',
    deactivateTitle: 'Deactivate the template',
    deactivateBody:
      'The template will stop being due in the App and stop counting in the missed records. The records it already has are kept. A reason is required.',
    actionError: 'The action could not be completed. Please try again.',

    // Template dialog
    sectionTemplate: 'Template',
    sectionFields: 'Fields to check',
    sectionFieldsHint:
      'Each field is something the operator has to answer. A KO or a number out of range opens a non-conformity.',
    fieldName: 'Name',
    fieldKind: 'Self-check type',
    fieldFrequency: 'Frequency',
    fieldFrequencyHint: 'Each period (a day, a week or a month) can be done only once.',
    fieldFrequencyLocked:
      'This template already has records: the frequency cannot be changed. Deactivate it and create a new one.',
    fieldZone: 'Zone',
    fieldZoneNone: 'No zone',
    fieldEquipment: 'Equipment',
    fieldEquipmentNone: 'No equipment',
    optionUnavailable: '(not available)',
    fieldSortOrder: 'Order',
    fieldSortOrderHint: 'Templates are shown in this order.',
    fieldInstructions: 'Instructions',
    fieldInstructionsHint: 'The operator sees them before doing the self-check.',
    fieldsEmpty: 'There are no fields yet. Add one to start.',
    addField: 'Add a field',
    fieldLabel: 'What is checked',
    fieldTypeLabel: 'Answer type',
    fieldTypeLocked: 'The type cannot be changed once the field is created.',
    fieldRequired: 'Required',
    fieldMin: 'Minimum',
    fieldMax: 'Maximum',
    fieldUnit: 'Unit',
    fieldRangeHint: 'Outside this range the value is KO.',
    fieldPosition: 'Field {{n}}',
    moveUp: 'Move up',
    moveDown: 'Move down',
    removeField: 'Remove',
    errorName: 'Enter the template name.',
    errorFieldLabel: 'Every field needs a name.',
    errorRange: 'The minimum cannot be greater than the maximum.',
    errorDuplicateName: 'There is already an active template with this name.',
    saveError: 'The template could not be saved. Please try again.',
  },
} as const;
